import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useChatStore } from '../../store/chatStore';
import { ChatHeader } from './header/ChatHeader';
import { ChatMessages } from './messages/ChatMessages';
import { ChatInput } from './input/ChatInput';
import { ChatButton } from './button/ChatButton';
import { useAgentStore } from '../../store/agentStore';

export function ChatWidget() {
  const { 
    isOpen, 
    messages, 
    setIsOpen, 
    sendMessage, 
    hasShownGreeting, 
    initializeChat 
  } = useChatStore();
  
  const { selectRandomAgent } = useAgentStore();

  // Select random agent and initialize chat when opened for the first time
  useEffect(() => {
    if (isOpen && !hasShownGreeting && messages.length === 0) {
      selectRandomAgent();
      setTimeout(() => {
        initializeChat();
      }, 50);
    }
  }, [isOpen, hasShownGreeting, messages.length, initializeChat, selectRandomAgent]);

  // Prevent body scroll when chat is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <>
      {/* Chat Button */}
      <div className="fixed bottom-4 right-4 z-[60]">
        {!isOpen && <ChatButton onClick={() => setIsOpen(true)} />}
      </div>

      {/* Chat Interface */}
      <AnimatePresence>
        {isOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-[70]">
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="absolute inset-0 bg-black/40 backdrop-blur-sm"
              onClick={() => setIsOpen(false)}
            />

            {/* Chat Window */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ 
                type: "spring",
                stiffness: 300,
                damping: 30
              }}
              className="relative w-[95%] md:w-[600px] lg:w-[800px] h-[90vh] max-h-[800px] 
                         bg-white rounded-xl shadow-2xl flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <ChatHeader onClose={() => setIsOpen(false)} />
              <div className="flex-1 overflow-hidden">
                <ChatMessages messages={messages} />
              </div>
              <ChatInput onSend={sendMessage} />
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </>
  );
}